import type { IntakeDevice } from "./intake-flow-types"

// Which device is the flow running on? Composite check — every signal must
// agree before we call it a desktop, because a false "desktop" hides the
// camera flow behind a QR handoff (much worse than a desktop seeing the
// phone UI). An explicit ?device= override wins in both directions so a user
// (or a dev) can always flip.

const DEVICE_PARAM = "device"

function isMobileUa(): boolean {
  return /Android|iPhone|iPad|iPod|Mobile|Silk/i.test(navigator.userAgent)
}

export function detectDevice(): IntakeDevice {
  try {
    const fine =
      window.matchMedia("(hover: hover)").matches &&
      window.matchMedia("(pointer: fine)").matches &&
      !window.matchMedia("(pointer: coarse)").matches
    const desktop =
      fine && navigator.maxTouchPoints === 0 && !isMobileUa() && window.innerWidth >= 900
    return desktop ? "desktop" : "phone"
  } catch {
    return "phone"
  }
}

// ?device=phone|desktop override beats detection.
export function resolveDevice(search: URLSearchParams): IntakeDevice {
  const override = search.get(DEVICE_PARAM)
  if (override === "phone" || override === "desktop") return override
  return detectDevice()
}

// Href for the "switch device" links — current URL with ?device= swapped and
// the continuation token preserved. Links both ways.
export function deviceOverrideHref(target: IntakeDevice): string {
  const url = new URL(window.location.href)
  url.searchParams.set(DEVICE_PARAM, target)
  return url.pathname + url.search
}
